import React from "react";
import { motion } from "framer-motion";

export default function Section({ id, className = "", children }) {
  return (
    <section id={id} className={`py-10  ${className}`.trim() }>
      <motion.div
        className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.2 }}
      >
        {children}
      </motion.div>
    </section>
  );
}
